//  Name: avatar
import { AVATAR } from '@/config'

export default {
  props: {
    image: {
      type: String
    },
    size: {
      type: String,
      required: false,
      default: '96'
    }
  },
  computed: {
    url () {
      // return (this.image) ? this.image : this.failover
      return this.failover
    },
    proportion () {
      let sizes = ['48', '64', '96', '128']
      return (sizes.indexOf(this.size) !== -1) ? 'is-' + this.size + 'x' + this.size : 'is-96x96'
    }
  },
  data () {
    return {
      failover: AVATAR
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/avatar/script.js